import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  useTranslate,
  useNotify,
  useRedirect,
  BooleanInput,
  required,
} from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { isJsonValidate } from 'src/helper/validatorJson'

export const EntityCreate = (props) => {
  const notify = useNotify()
  const redirect = useRedirect()
  const translate = useTranslate()

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.entity') }
    })
    redirect('/entity')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.entity') }
    })
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_entity')}>
        <SimpleForm>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.description')} required>
              <TextInput source='description' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.reference')}>
              <TextInput
                fullWidth
                source='reference'
                label=''
                validate={isJsonValidate}
                format={(v) => {
                  return JSON.stringify(v ? v : undefined)
                }}
                parse={(v) => {
                  try {
                    if (v.length >= 2) {
                      return JSON.parse(v)
                    }
                  } catch (e) {
                    notify('ra.field.invalid_json', { type: 'error' })
                    return undefined
                  }
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.menu')}>
              <BooleanInput label={translate('ra.field.menu')} source='menu' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
